<template>
    <div>
        <transition appear name="popup-slide-up">
            <div class="app-message-overlay" v-if="is_open && settings['app.show_mobile_app_ad'] == 1" @click.self="hideMessage">
                <div class="app-message-wrapper">
                    <div class="app-message-content">
                        <img src="//i.imgur.com/d3RP4bL.png">
                        <p>{{ settings['title'] }} {{ translations['app.now_has_app'] }}</p>
                        <span>{{ settings['title'] }} {{ translations['app.best_experience'] }}</span>
                    </div>
                    <div class="app-message-download">
                        <div class="cancel-button" @click="hideMessage">
                            {{ translations['app.not_now'] }}
                        </div>
                        <template v-if="device === 'android'">
                            <a href="market://details?id=com.webuildapps.huddle" target="_blank" @click="hideMessage">
                                <img src="/img/download-play-store.png">
                            </a>
                        </template>
                        <template v-else>
                            <a href="https://itunes.apple.com/lb/app/huddle-community-e-learning/id1447940450" target="_blank" @click="hideMessage">
                                <img src="/img/download-app-store.png">
                            </a>
                        </template>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    import {mapState} from 'vuex';

    export default {
        data() {
            return {
                is_open: false,
            }
        },

        computed: {
            ...mapState([
                'translations',
                'settings'
            ]),

            device() {
                if(navigator.userAgent.toLowerCase().indexOf("android") > -1) {
                    return 'android';
                } else {
                    return 'ios';
                }
            },
        },

        methods: {
            hideMessage() {
                this.is_open = false;

                //set cookie
                Cookies.set('app-message-dismissed', 1, {
                    expires: 7
                });
            },

            download() {
                if(navigator.userAgent.toLowerCase().indexOf("android") > -1) {
                    window.location.href= "market://details?id=com.webuildapps.huddle";
                } else {
                    window.location.href = 'https://apps.apple.com/lb/app/huddle-community-e-learning/id1447940450';
                }
            }
        },

        mounted() {
            //check for mobile app cookie
            let cookie = Cookies.get('app-message-dismissed');

            if(cookie === undefined) {
                this.is_open = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .app-message-overlay {
        display: none;
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        top: 0;
        z-index: 9997;

        @media(max-width: 767px) {
            display: block;
        }

        .app-message-wrapper {
            flex-direction: row;
            position: fixed;
            bottom: 0;
            background: #fff;
            z-index: 9997;
            width: 100%;
            box-shadow: 0 -5px 9px -6px #757575;
            display: flex;
            flex-wrap: wrap;

            .app-message-content {
                flex-direction: column;
                padding-top: 20px;
                padding-bottom: 0;
                padding-left: 30px;
                padding-right: 30px;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: center;
                width: 100%;
                text-align: center;

                img {
                    max-width: 100px;
                    padding-bottom: 15px;
                }

                p {
                    font-size: 16px;
                    font-weight: 600;
                    color: #464646;
                    margin: 0;
                }

                span {
                    line-height: 22px;
                    padding-top: 5px;
                    font-size: 13px;
                    font-weight: 400;
                    color: #9e9e9e;
                    margin: 0;
                }
            }
        }

        .app-message-download {
            justify-content: space-between;
            border-top: 1px solid #f7f7f7;
            padding-left: 30px;
            padding-right: 30px;
            padding-top: 15px;
            margin-top: 15px;
            padding-bottom: 20px;
            display: flex;
            flex-wrap: wrap;
            width: 100%;

            .cancel-button {
                display: inline-block;
                text-align: center;
                border-radius: 3px;
                padding: 12px;
                padding-left: 25px;
                padding-right: 25px;
                transition: color 0.3s;
                font-weight: 600;
                -webkit-appearance: none;
                user-select: none;
                color: #808080;
                cursor: pointer;

                &:hover {
                    color: #222;
                }
            }

            img {
                max-width: 150px;
            }
        }
    }

    //popup slide up
    .popup-slide-up-enter-active {
        transition: background 0.5s ease-out;

        .app-message-wrapper {
            transition: bottom 0.5s ease-out;
        }
    }

    .popup-slide-up-leave-active {
        transition: background 0.2s ease-out;

        .app-message-wrapper {
            transition: bottom 0.2s ease-out;
        }
    }

    .popup-slide-up-enter, .popup-slide-up-leave-to {
        background: rgba(0, 0, 0, 0);

        .app-message-wrapper {
            bottom: -250px !important;
        }
    }

    .popup-slide-up-enter-to, .popup-slide-up-leave {
        background: rgba(0, 0, 0, 0.4);

        .app-message-wrapper {
            bottom: 0px !important;
        }
    }
</style>
